export default "__VITE_ASSET__ctl7RltI__"